/* istanbul ignore next */
export default ({
  palette: {
    primary: { dark, light, normal }
  },
  spacing: { unit }
}) => ({
  '& .table > tbody > tr.selected': {
    backgroundColor: light
  },
  '& .btn.btn-action': {
    color: normal,
    '&:hover': {
      color: dark
    },
    '&:focus': {
      color: dark
    }
  },

  '& .table-subrow': {
    '& tr.grid-row td:first-of-type': {
      paddingLeft: unit * 3
    },
    '& .btn-grid-expand': {
      left: unit / 2
    }
  },

  '& .table >': {
    '& thead >': {
      '& tr > th': {
        textTransform: 'capitalize'
      }
    },
    '& tbody >, tfoot >': {
      '& tr > th, tr > td': {
        padding: `${unit * 1.37}px ${unit * 2.5}px ${unit}px`,
        '& .btn': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textAlign: 'left',
          whiteSpace: 'nowrap',
          width: '100%',
          '& + .dropdown-toggle': {
            width: 'initial'
          }
        }
      },
      '& tr.grid-subrow > td.js-region-grid-subrow': {
        padding: '11px',
        '& .table': {
          backgroundColor: 'inherit',
          tableLayout: 'auto',
          '& thead, tbody': {
            backgroundColor: 'inherit',
            '& tr': {
              backgroundColor: 'inherit',
              '& td, th': {
                borderTop: 'none',
                borderWidth: '0 0 1px 0'
              }
            }
          }
        }
      }
    }
  },

  '& .grid-controls-section .grid-saved-views .list .items-view .item-list [data-value*="-static-view"]':
    {
      '& .grid-saved-views-remove, & .grid-save-view-make-default': {
        display: 'none'
      }
    },

  '& .manage-columns': {
    '& .columns-checkboxes-container, & .grid-manage-columns-buttons > .btn-secondary': {
      textTransform: 'capitalize'
    }
  },

  '& .grid-filter-selection > .region-grid-select-filter': {
    textTransform: 'capitalize'
  },

  '& .flex-dropdown-wrapper': {
    display: 'flex',
    alignItems: 'center'
  }
});
